import {UnreadMessagesValueObject} from '../ValueObjects/UnreadMessagesValueObject.js'
import NotificationsRepository from './NotificationsRepository.js'

/**
 * @class
 * @implements NotificationsRepository
 */
export default class EmptyNotificationsRepository extends NotificationsRepository {
  constructor({pendingPtaVOFactory, unseenSavedSearchMatchesByIdVOFactory}) {
    super()

    this._pendingPtaVOFactory = pendingPtaVOFactory
    this._unseenSavedSearchMatchesByIdVOFactory = unseenSavedSearchMatchesByIdVOFactory
  }

  getPendingPta = () => Promise.resolve(this._pendingPtaVOFactory({pendingPta: 0}))

  setPendingPta = () => Promise.resolve()

  getUnreadMessages = () => Promise.resolve(UnreadMessagesValueObject.create({unreadMessages: 0}))

  getUnseenSavedSearchMatches = () => Promise.resolve(0)

  getUnseenSavedSearchMatchesById = () =>
    this._unseenSavedSearchMatchesByIdVOFactory({
      unseenSavedSearchMatchesById: {counter: 0}
    })
}
